import React, { useState, useEffect, useCallback } from 'react';
import { Container, Tabs, Tab, Row, Col } from 'react-bootstrap';
import Helmet from 'react-helmet';

import { ApiServiceServerless } from '../../xhr_libs';
import PageHeader from '../../components/PageHeader';
import UserManagement from '../../components/UserManagement';
import PortfolioSettings from './PortfolioSettings';
import PortfolioOrganizations from './PortfolioOrganizations';
import { useTabUrl } from '../../helpers/tracked';
import {
  usePortfolioRoles,
  usePortfolioRolesWeight,
} from '../../helpers/checkRoles';

const PAGE_TITLE = 'Portfolio: ';

const styles = {
  no_portfolio: {
    width: '100%',
    marginTop: '30px',
    marginBottom: '30px',
  },
};

function EditPortfolio(props) {
  const { match, history, showToast } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [portfolio, setPortfolio] = useState({
    id: '',
    name: '',
    organizations: [],
  });

  const [activeTab, setActiveTab] = useTabUrl('portfolio-settings');

  const updatePortfolioAccess = usePortfolioRoles(
    parseInt(portfolio.id),
    'portfolio',
    'update'
  );
  const deletePortfolioAccess = usePortfolioRoles(
    parseInt(portfolio.id),
    'portfolio',
    'delete'
  );

  const createPortfolioUserAccess = usePortfolioRoles(
    parseInt(portfolio.id),
    'portfolio_user',
    'create'
  );
  const updatePortfolioUserAccess = usePortfolioRoles(
    parseInt(portfolio.id),
    'portfolio_user',
    'update'
  );
  const deletePortfolioUserAccess = usePortfolioRoles(
    parseInt(portfolio.id),
    'portfolio_user',
    'delete'
  );

  const portfolioRoleWeight = usePortfolioRolesWeight(parseInt(portfolio.id));

  const getPortfolio = useCallback((id) => {
    setIsLoading(true);
    ApiServiceServerless.get(`/portfolios/${id}`, {
      authorization_id: id,
    })
      .then((res) => {
        setPortfolio(res.data);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    getPortfolio(match.params.id);
  }, [match.params.id, getPortfolio]);

  return (
    <>
      <Container className='et-container et-main-tab-content'>
        <Helmet>
          <title>
            {PAGE_TITLE}
            {portfolio.name}
          </title>
        </Helmet>
        <PageHeader
          titlePrepend={PAGE_TITLE}
          title={portfolio.name || 'Loading Portfolio...'}
        />

        <Tabs id='portfolio-tabs' activeKey={activeTab} onSelect={setActiveTab}>
          <Tab eventKey='portfolio-settings' title='Portfolio Settings'>
            {parseInt(portfolio.id) === -1 ? (
              <div
                style={styles['no_portfolio']}
              >{`No Selected Portfolio.`}</div>
            ) : (
              <Row style={{ marginTop: '16px' }}>
                <Col />
                <Col lg={8} sm={10}>
                  <PortfolioSettings
                    portfolio={portfolio}
                    showToast={showToast}
                    setPortfolio={setPortfolio}
                    history={history}
                    updateAccess={updatePortfolioAccess}
                    deleteAccess={deletePortfolioAccess}
                  />
                </Col>
                <Col />
              </Row>
            )}
          </Tab>
          <Tab eventKey='organizations' title='Organizations'>
            {parseInt(portfolio.id) === -1 ? (
              <div
                style={styles['no_portfolio']}
              >{`No Selected Portfolio.`}</div>
            ) : (
              <PortfolioOrganizations
                portfolio={portfolio}
                setPortfolio={setPortfolio}
                showToast={showToast}
                isLoading={isLoading}
                deleteAccess={deletePortfolioAccess}
              />
            )}
          </Tab>
          <Tab eventKey='user-management' title='User Management'>
            {parseInt(portfolio.id) === -1 ? (
              <div style={styles['no_portfolio']}>
                {'No Selected Portfolio.'}
              </div>
            ) : (
              <UserManagement
                entityType={'portfolio'}
                entityId={parseInt(portfolio.id)}
                showToast={showToast}
                createAccess={createPortfolioUserAccess}
                updateAccess={updatePortfolioUserAccess}
                deleteAccess={deletePortfolioUserAccess}
                roleWeight={portfolioRoleWeight}
              />
            )}
          </Tab>
        </Tabs>
        <div style={{ marginBottom: '20px' }} />
      </Container>
    </>
  );
}

export default EditPortfolio;
